export default __webpack_public_path__ + "static/media/bethan_copper.718a92d1.png";